import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue"
import Icon from "@/components/widgets/icons/Icon.vue"
import { ScopeService } from "@/gql"
import ScopeServiceTeamRoleForm from "./ScopeServiceTeamRoleForm.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceAttributesCard',
  props: {
    service: null
  },
  setup(__props: any) {



const showTeamRoleForm = ref(false)

const closeTierFormModal = () => {
  showTeamRoleForm.value = false
}

return { __sfc: true,showTeamRoleForm, closeTierFormModal, Icon, ScopeServiceTeamRoleForm }
}

})